function GET_USERINFO() {
  return {
    method: "GET",
    endpoint: `/services/data/v65.0/chatter/users/me`,
  };
}

export default GET_USERINFO;
